import { Injectable } from '@angular/core';

@Injectable()
export class PortalSettingsLocalService {
  portalEnabled: boolean;
  setPortalEnabled(portalEnabled) {
    this.portalEnabled = portalEnabled;
  }
}
